import InvoiceDocument from './InvoiceDocument.view'

export default InvoiceDocument;